import axios from "axios";
import { logout } from "../lib/auth";
import { CONST } from "../config/const";

export async function getAddress(zipCode: string) {
  try {
    const path = "address";
    const params = {
      zipCode,
    };
    const response = await axios.get(CONST.apiCognitoUrl + path, {
      params,
    });
    const address = response.data.address as string;
    return address;
  } catch (error) {
    // logout();
    return "";
  }
}
